import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "GeotargetingTool" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainContent = _resolveComponent("MainContent")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.routeIsListing)
      ? (_openBlock(), _createBlock(_component_MainContent, { key: 0 }))
      : (_ctx.isModalActive)
        ? (_openBlock(), _createBlock(_component_Modal, { key: 1 }))
        : _createCommentVNode("v-if", true)
  ]))
}